import React, { useEffect, useState } from 'react'
import '../AttendTeamAdmin/HRAdmin.css'
import images1 from '../../assets/images1.jfif'
import { Col, Row } from 'antd'
import { useSelector } from 'react-redux';
import { BASE_URL, FetchStaff, STAFF_ROLE } from '../../utils/constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import StaffForm from '../AttendTeamAdmin/StaffForm';
import HeadStaffModel from '../AttendTeamAdmin/headStaffModel';
function EmpTeamAdmin() {
  const [AttendanceHeadsData,setAttendanceHeadsData] = useState(null)
  const userInfo = useSelector((state) => state.signUp.signUpDetails);

  const [formVisible, setFormVisible] = useState(false);
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const {
      companyName = "",
      logo = "",
      firstName = "",
      lastName = "",
      email = "",
      phoneNumber = "",
      aadharNumber = "",
    } = useSelector((state) => state.signUp.signUpDetails);

    const showForm = (item) => {
      // setEditItem(item);
      console.log('open')
      setFormVisible(true);
    };
  const hideForm = (item) => {
      // setEditItem(item);
      console.log('open')
      setFormVisible(false);
      getStaffList()
    };
    useEffect(() => {
      getStaffList();
    }, []);
    const getStaffList = async () =>{
      // const storedDataString = localStorage.getItem("roles");
      //  const storedData = JSON.parse(storedDataString);
      //  const objectWithUniqueId1 = storedData.find(item => item.uniqueId === STAFF_ROLE.AttendanceHeads);
      //   console.log(objectWithUniqueId1);
      const token = localStorage.getItem('authToken');
    
      try{
          const fetchData = async () => {
            const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
              method: "POST",
               headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `${token}`,
                        
                      },
              body: JSON.stringify({roles:[STAFF_ROLE.EmployeeHeads]}),
            });
            
            if (response.ok) {
              const data = await response.json();
              const activeStaff = data.data.filter(item => item.isActive);
              console.log('activeStaff',activeStaff)
              setAttendanceHeadsData(activeStaff)
            
            } else {
              const data = await response.json();
              console.log('departmenterr',data)
              toast.error(data.errorMessage, {
                position: toast.POSITION.TOP_RIGHT,
              });
              
            }
          };
          await fetchData();
        } catch (error) {
          console.error('Error updating designation:', error);
      }
    }
  return (
    <div className='p-2'>
            <p className='text-sm text-[#00305F] font-sbold'>Here, you can setup your employee management team and their access to various features. This section only be visible to the people who have been given BO access to it.</p>
            <p className='text-sm text-[#00305F] font-sbold mt-1'>HR heads have the same right to the employee module as the BO (Bussiness Owner). They can manage the employee team instead of the BO, and can only access the employee module completely.</p>
            <div className='mt-4'>
                <p className='text-sm text-[#4B8AEB] font-sbold !mb-2'>Business Owner (BO)</p>
                <div className='bg-[#EDF0F4] rounded-[20px] !p-4'>
                    <div className='text-center bg-[#D8DEE7] rounded-[20px] w-56 !py-4'>
                        <div className='!mb-2 !table !mx-auto'>
                        {userInfo?.userRole == "businessOwner" ?
                            <img className="w-[70px] h-[70px] rounded-full" src={userInfo?.logo} alt="" />
                            :
                            <img className="w-[70px] h-[70px] rounded-full" src={userInfo?.boOwner?.logo} alt="" />
                        }                        </div>
                        <div className='text-lg font-sbold leading-none'>
                        {userInfo?.userRole == "businessOwner" ?
                              <p>
                               {capitalizeFirstLetter(userInfo?.firstName)} {capitalizeFirstLetter(userInfo?.lastName)}
                                 </p> :
                                 <p>
                                   {capitalizeFirstLetter(userInfo?.boOwner?.firstName)} {capitalizeFirstLetter(userInfo?.boOwner?.lastName)} 

                                 </p>
                                 }                        </div>
                        <div className='text-sm !font-sbold !mb-4'>Business Owner</div>
                    </div>
                </div>
            </div>
            <div className='flex justify-between items-center !mt-5 !mb-2'>
                <p className='text-sm text-[#4B8AEB] font-sbold'>Employee Heads</p>
                {userInfo?.userRole == "businessOwner" && (
                <button  className='h-[35px] border !border-[#00305F] px-6 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all' onClick={() => showForm()}>+ Add more</button>
               )}
            </div>
            <div className='bg-[#EDF0F4] rounded-[20px] !p-4'>
            <div className='flex flex-wrap'>
                {AttendanceHeadsData?.map((data, index) => 
                <div className='!mr-4 mb-2 bg-[#D8DEE7] !p-4 rounded-[21px] !pr-10'>
                    <div className='flex items-center'>
                        <div className=''>
                            <img className="min-w-[70px] w-[70px] h-[70px] rounded-full" src={data?.logo}/>
                        </div>
                        <div className='pl-3'>
                          <p className='font-sbold'>{capitalizeFirstLetter(data?.firstName)} {capitalizeFirstLetter(data?.lastName)}</p>
                          <p className='text-sm'>{capitalizeFirstLetter(data?.designation?.designationName)}</p>
                        </div>
                    </div>
                </div>
                   )}
               
            </div>
            <p className='text-sm text-[#00305F] !mt-2'>Finance Heads have the same rights as BO but they all report to BO and, cannot remove/edit the BO</p>
            </div>
            {/* <StaffForm
        open={formVisible}
        onCancel={hideForm}
        isAttendanceHead={false}
        isEmployeeHead={true}
       /> */}
        <HeadStaffModel
        open={formVisible}
        onCancel={hideForm}
        isAttendanceHead={false}
       />
        </div>
  )
}

export default EmpTeamAdmin